import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Card, Grid, Typography, Tooltip } from '@material-ui/core';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import axios from 'axios';
import { getDynamicConfigValue } from '../../dynamicConfig';
import { getKeymakerApiKey } from "../../graphql/keymakerApiKey";

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: 300,
    height: 160
  },
  container: {
    marginTop: theme.spacing(1),
    height: 45
  },
  content: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    height: 65
  },
  titleSpace: {
    alignContent: 'center',
    marginLeft: theme.spacing(1)
  },
  title: {
    fontWeight: 700
  },
  scoreSpace: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    border: '1px dashed #2979ff',
    justifyContent: 'center',
    height: 30,
    width: 60
  },
  score: {
    cursor: 'pointer',
    color: '#2979ff'
  },
  button: {
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
    alignContent: 'center'
  },
  list: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2)
  }
}));

const RecommendedAH = props => {
  const classes = useStyles();
  const {
    id,
    recommendation,
    AHCallback,
    setALoad,
    setBaseAccount,
    hops,
    selectedCard,
    setSelectedCard,
    handleOpen,
    setDetails,
    setAssociation,
    setOtherCard,
    // setVisQuery,
    alternatePhaseIdMap,
    ...rest
  } = props;

  const handleVisualization = async (idx, item, details) => {
    setSelectedCard(idx);
    AHCallback(item);
    setOtherCard();
    var query = '';
    var returnStatement = 'Return ';
    Object.values(details).map(value => {
      query =
        query + value.query.substring(0, value.query.indexOf('RETURN ')) + '\n';
      returnStatement =
        returnStatement +
        value.query.substring(
          value.query.indexOf('RETURN ') + 7,
          value.query.length
        ) +
        ',';
      //console.log(returnStatement);
    });
    // const bloomQuery = getbloomQuery(
    //   returnStatement.substring(0, returnStatement.length - 1)
    // );
    let user = JSON.parse(localStorage.getItem('User'));
    let bloomQuery =
      query + returnStatement.substring(0, returnStatement.length - 1);
    bloomQuery = bloomQuery.replace(/\n/g, ' ');
    bloomQuery = bloomQuery.replaceAll("'", '\\\\"');
    await axios
      .post(process.env.REACT_APP_DASHBOARD_URI, {
        query: `
        mutation StoreBloomPerspective($bloomQuery:String!,$email:String!){
          storeBloomPerspective(bloomQuery:$bloomQuery,email:$email)
        }
        `,
        variables: { bloomQuery: bloomQuery, email: user.email }
      })
      .then(data => {
        console.log(data);
      })
      .catch(err => {
        console.log(err);
      });
    // setVisQuery(
    //   query +
    //     returnStatement.substring(0, returnStatement.length - 1) +
    //     ' LIMIT 100'
    // );
  };

  const handlePopup = (details, idx) => {
    setDetails(details);
    setSelectedCard(idx);
    handleOpen(true);
  };

  const handleRecommendation = () => {
    var params = localStorage.getItem('InputParams') + `,hopsCount:${hops}`;
    setALoad(true);
    setAssociation(undefined);
    const phaseList = Object.keys(alternatePhaseIdMap).filter(
      key => alternatePhaseIdMap[key] === true
    );
    console.log(phaseList);
    getRecommendationsByPhases(phaseList, params);
  };
  const getRecommendationsByPhases = async (phaseId, params) => {
    // const keymakerApiKey = getDynamicConfigValue('REACT_APP_KEYMAKER_API_KEY');
    const keymakerApiKey = getKeymakerApiKey();
    await axios
      .post(getDynamicConfigValue('REACT_APP_RECOMMENDATION_URI'), {
        query: `
         query {
           recommendations:recommendationsForPhases(
             phaseID:[${phaseId}]
             params: { ${params} }
             first: 25
             skip: 0
           ) {
             item
             score
             details
           }
         }
       `
      },
      {
        headers: { 
          "api-key": keymakerApiKey
         },
      })
      .then(result => {
        setALoad(false);
        const { data } = result;
        if (data.errors === undefined) {
          setAssociation(data);
        } else {
          setAssociation(undefined);
          alert('Check your Input...');
        }
      })
      .catch(error => {
        setALoad(false);
        setAssociation(undefined);
        alert('Check your Input...');
      });
  };
  const explore = (idx, item) => {
    if (
      localStorage.getItem('mode') === 'true' &&
      localStorage.getItem('isAssociation') === 'false'
    ) {
      if (window.location.pathname !== '/solution/Entity%20Resolution') {
        return (
          <Grid item xs={3} className={classes.button}>
            <Button
              variant="contained"
              disabled={
                window.location.pathname === '/solution/Shared%20PII' ||
                window.location.pathname === '/solution/Entity%20Resolution' ||
                window.location.pathname === '/solution/Credit%20Fraud'
                  ? true
                  : false
              }
              size="large"
              color="secondary"
              style={{ left: '30%' }}
              onClick={() => {
                handleRecommendation();
                setBaseAccount(item.accountHolderID);
              }}>
              <GroupAddIcon
                style={{ fontSize: '140%' }}
                component="svg"
                variant="contained"
              />
            </Button>
          </Grid>
        );
      }
    }
  };

  return recommendation.data.recommendations.map(
    ({ item, score, details }, idx) => (
      <Card
        key={item.accountHolderID}
        className={classes.root}
        style={{
          border: idx === selectedCard ? '2px solid #2979ff' : '',
          elevation: idx === selectedCard ? 1 : 0
        }}
        {...rest}>
        <Grid container item xs={12} className={classes.container}>
          <Grid item xs={11} className={classes.titleSpace}>
            <Tooltip title={item.accountName} enterDelay={1000}>
              <Typography
                className={classes.title}
                align="center"
                gutterBottom={false}
                variant="h5"
                color="secondary">
                {item.accountName.length > 40
                  ? item.accountName.substring(0, 40) + '...'
                  : item.accountName}
              </Typography>
            </Tooltip>
          </Grid>
        </Grid>
        <Grid container item xs={12}>
          <Grid item xs={6} className={classes.content}>
            <Typography variant="h6">
              Account-ID: {item.accountHolderID}
            </Typography>
            <div>
              {item.gender ? (
                <Typography variant="h6">Gender: {item.gender}</Typography>
              ) : null}
            </div>
          </Grid>
          <Grid item xs={3} className={classes.button}>
            <Button
              variant="contained"
              size="large"
              color="secondary"
              style={{ left: '30%' }}
              onClick={() => {
                handleVisualization(idx, item, details);
              }}>
              <BubbleChartIcon
                style={{ fontSize: '140%' }}
                component="svg"
                variant="contained"
              />
            </Button>
          </Grid>
          <Grid item xs={6} className={classes.scoreSpace}>
            <Typography
              className={classes.score}
              align="center"
              variant="h6"
              onClick={() => {
                handlePopup(details, idx);
              }}>
              SCORE: {score.toFixed(2)}
            </Typography>
          </Grid>
          {explore(idx, item)}
        </Grid>
      </Card>
    )
  );
};

RecommendedAH.propTypes = {
  className: PropTypes.string
};

export default RecommendedAH;
